import React, { useEffect, useState } from "react";
import { Table2, Label } from "../../../../../../../../components";
import config from "constants/config";
import { Alert, Button, Collapse } from "@paylixecommerce/shared/components";
import useTheme from "../../../../../../../../hooks/useTheme";

import "../modals.scss";


const DISCOUNT_FIELDS = {
	quantity: '',
	value: '',
	type: config.DISCOUNT_TYPE[0],
}

export const DiscountTable = ({ data, edit, remove, currency, skipButtons }) => {

	if(skipButtons && !data.length) {
		return null
	}

	let columns = [{
		accessor: 'quantity',
		Header: 'Qty'
	}, {
		accessor: 'value',
		Header: 'Discount',
		Cell: ({ row }) => <span>{row.original.type === "FIXED" ? config.CURRENCY_LIST[currency] : ''}{row.original.value}{row.original.type !== "FIXED" ? "%" : ""}</span>,
	}, {
		accessor: 'type',
		Header: 'Type',
		Cell: ({ row }) => {
			return <div className="badge badge-confirmation">
				{row.original.type}
			</div>
		},
	}, {
		accessor: 'options',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }) => (
			<div className="widget-table-options gap-3">
				<Button onClick={() => edit(row.index)} iconName="edit" variant="secondary" size="large" square />
				<Button onClick={() => remove(row.index)} iconName="trash" variant="warning" size="large" square />
			</div>
		)
	}];


	if(skipButtons) {
		columns.pop()
	}

	if(!data.length) {
		return null
	}

	return <div className="widget-modal-table">
		<Table2 data={data} columns={columns} notFound="No discounts" />
	</div>
};


const DiscountForm = ({ data, setData, cancel, update, currency, active }) => {

	const [showMore, setMore] = useState(false);

	if(!active) {
		return null
	}

	return <div className="custom-widget">

		<Alert variant="blue" size="small" className="mb-4">
			<div>
				You can enable volume discounts for this product: <br/>
				These discounts will give customers X% or $X amount if they purchase Y quantity. <br/>
				{!showMore &&
					<span className="link-like" onClick={() => setMore(true)}>Show More Details</span>
				}
				<Collapse isOpen={showMore}>
					<div>
						For example, let’s take a product “Activation Key” that costs <b>$5.00</b> with a single volume discount of <b>25%</b> for <b>quantity 10</b>. <br/>
						If the customer buys <b>5</b> “Activation Key”, the price is <b>$25.00</b>. <br/>
						However, with a volume discount configured, the customer is prompted to add <b>five</b> more “Activation Key” to get a <b>25% discount</b>! <br/>
						You can add more than one volume discount to your product configuration.
						<br/>
						Volume discounts are the ideal method to push sales.
					</div>
				</Collapse>
			</div>
		</Alert>

		<div className="custom-widget-body flex-wrap gap-1">

			<div className="w-30">
				<label className="paylixecommerce-label" htmlFor="name" >Qty</label>
				<input className="paylixecommerce-input" type="number" value={data.quantity} onChange={(e) => setData({
					...data,
					quantity: e.target.value
				})} placeholder="1" />
			</div>

			<div className="w-30">
				<label className="paylixecommerce-label" htmlFor="type" >Type</label>
				<select onChange={(e) => setData({
					...data,
					type: e.target.value
				})} value={data.type} className="paylixecommerce-select">
					{config.DISCOUNT_TYPE.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
				</select>
			</div>


			<div className="w-30 position-relative">
				{data.type === "FIXED" ? <div className="discount-currency">
					{config.CURRENCY_LIST[currency]}
				</div> : null}
				<div className="">
					<label className="paylixecommerce-label" htmlFor="placeholder" >Discount</label>
					<input className="paylixecommerce-input" type="text" value={data.value} onChange={(e) => setData({
						...data,
						value: e.target.value
					})} placeholder="10" />
				</div>
				{data.type !== "FIXED" ? <div className="discount-currency" style={{ right: 0 }}>
					%
				</div> : null}
			</div>

		</div>

		<div className="custom-widget-footer">
			<Button className="mr-3" size="large" variant="secondary" onClick={cancel}>
				Cancel
			</Button>
			<Button onClick={update} size="large" disabled={!data.quantity || !data.value ? "disabled" : ""}>
				Save
			</Button>
		</div>

	</div>
}

export default ({ form, fields, updateFields, setModal, modal, currency, skipButtons }) => {

	const [currentIndex, setCurrentIndex] = useState(null);
	const [data, setData] = useState({
		type: "FIXED"
	});
	const isDark = useTheme();

	useEffect(() => {
		if(currentIndex === 0 || currentIndex) {
			let field = fields[currentIndex] ? fields[currentIndex] : DISCOUNT_FIELDS;

			setData({
				type: field.type && (field.type.value ? field.type.value : field.type),
				quantity: field.quantity,
				value: field.value,
			});
		}
	}, [currentIndex]);


	const addField = (index) => {
		setCurrentIndex(index ? index : true);
	};

	const updateField = () => {

		if(fields[currentIndex]) {
			fields[currentIndex] = data;
			updateFields([
				...fields
			]);
		} else {
			updateFields([
				...fields,
				data
			]);
		}

		setCurrentIndex(null);
		setModal(null);
	}

	const cancelEdit = () => {
		setCurrentIndex(null);
		setModal(null);
	}

	const editField = (index) => {
		setCurrentIndex(index);
		setModal(fields[index]);
	}

	const removeField = (index) => {

		if(fields[index]) {

			let updated = Object.assign([], fields);
			updated.splice(index, 1);
			updateFields([
				...updated
			]);

		}

		setCurrentIndex(null);
	}

	const active = (currentIndex === 0 || currentIndex);

	if(form.values.type === "SUBSCRIPTION") {
		return null
	}


	return <div className="widget-modal">

		{skipButtons ? null : <Label tooltip="Add volume discounts to encourage your customers to purchase higher quantities" name="volume" label="Volume Discounts" />}

		<DiscountTable data={fields} edit={editField} remove={removeField} currency={currency} />

		{modal ? <DiscountForm update={updateField} cancel={cancelEdit} currency={currency} setData={setData} active={modal} data={data}/> : <Button className="w-100" size="large" variant={isDark ? "primary" : "secondary"} iconName="plus" iconPosition="left" onClick={() => setModal(true)}>Discounts Volume</Button>}

	</div>
}
